import * as Sentry from "@sentry/react";

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  sendDefaultPii: false,
  enabled: import.meta.env.PROD,
});

// Suppress findDOMNode warnings in development
if (import.meta.env.DEV) {
  const originalConsoleError = console.error;
  console.error = (...args) => {
    if (
      typeof args[0] === "string" &&
      args[0].includes("Warning: findDOMNode is deprecated")
    ) {
      return;
    }
    originalConsoleError.apply(console, args);
  };
}
